import { Box, Container, Divider, Typography } from '@mui/material'
import React, { memo } from 'react'
import Option from '../forms/Option'
import { useCreateQuestionMulti } from '../../hooks/useCreateQuestionMulti'

const MultipleABQuestion = memo(({ dataQuestion, indices, form }) => {
  const options = useCreateQuestionMulti(dataQuestion)
  return (
    <Box display={'flex'} flexDirection={'column'} height={'100%'} mx={'-1rem'}>
      <Box
        bgcolor={'#9AA5EA'}
        width={'100%'}
        sx={{
          borderBottomLeftRadius: '20px',
          borderBottomRightRadius: '20px',
        }}
      >
        <Divider
          sx={{
            backgroundColor: 'white',
            height: '3px',
          }}
        />
        <Box px={2} py={3}>
          <Container style={{ display: 'flex', justifyContent: 'center' }}>
            {dataQuestion.link_gambar === '' ? null : (
              <img src={dataQuestion.link_gambar} alt="img-soal" />
            )}
          </Container>
          <Typography
            textAlign={'justify'}
            fontWeight={500}
            fontSize={'14px'}
            color={'white'}
            letterSpacing={1.2}
            lineHeight={1.7}
            sx={{
              textAlign: 'center',
              whiteSpace: 'pre-wrap',
            }}
          >
            {dataQuestion.soal}
          </Typography>
        </Box>
      </Box>
      <Box height={'100%'} pt={5} px={1}>
        <Option
          name={`question_${indices}`}
          control={form.control}
          errors={form.formState?.errors}
          options={options}
        />
      </Box>
    </Box>
  )
}, arePropEqual)

function arePropEqual(oldProps, newProps) {
  return oldProps.indices !== newProps.indices
}
export default MultipleABQuestion
